/* eslint-disable react/prop-types */
import React, { Component } from 'react';

import Classes from './ConfigurationScreenContentPlaylistUserGenreItem.css';

class ConfigurationScreenContentPlaylistUserGenreItem extends Component {
  render() {
    return (
      <div className={Classes.Item}>
        <p> 
          <span> 
            &nbsp; 
            {this.props.name}
            &nbsp;
          </span> 
        </p>
      </div>
    );
  }
}


export default ConfigurationScreenContentPlaylistUserGenreItem;
